import {
  LIST_PRODUCT_FILTER_WINE_TYPES_REQUEST,
  LIST_PRODUCT_FILTER_WINE_VARIETALS_REQUEST,
  LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_REQUEST,
  LIST_PRODUCT_FILTER_WINE_REGIONS_REQUEST,
  LIST_PRODUCT_FILTER_WINE_APPELLATIONS_REQUEST,
  LIST_PRODUCT_FILTER_VENDORS_REQUEST
} from './constants';

export const listWineTypes = (slug) => ({
  type: LIST_PRODUCT_FILTER_WINE_TYPES_REQUEST,
  slug
});

export const listWineVarietals = (slug) => ({
  type: LIST_PRODUCT_FILTER_WINE_VARIETALS_REQUEST,
  slug
});

export const listWineCountryCodes = (slug) => ({
  type: LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_REQUEST,
  slug
});

export const listWineRegions = (slug) => ({
  type: LIST_PRODUCT_FILTER_WINE_REGIONS_REQUEST,
  slug
});

export const listWineAppellations = (slug) => ({
  type: LIST_PRODUCT_FILTER_WINE_APPELLATIONS_REQUEST,
  slug
});

export const listVendors = (slug) => ({
  type: LIST_PRODUCT_FILTER_VENDORS_REQUEST,
  slug
});
